import React from "react";
import { shallow } from "../../hooks/hookHelpers";
import { useFeedbackStore } from "../../stores/feedbackStore";
import { ProblemInput } from "./Inputs";
import { FeedbackModalProps, ModalDialog } from "./ModalDialog";
import { Selector, SelectorItem } from "./Selector";

const bugPriorityList: Array<SelectorItem<number>> = [
    {
        display: "Minor",
        value: 100,
    },
    {
        display: "Major",
        value: 200,
    },
    {
        display: "Critical",
        value: 300,
    },
    {
        display: "Blocker",
        value: 400,
    },
];

const bugETList: Array<SelectorItem<string>> = [
    {
        display: "Last 15 min",
        value: "PT15M",
    },
    {
        display: "Last Hour",
        value: "PT1H",
    },
    {
        display: "Today",
        value: "P1D",
    },
    {
        display: "Unsure",
        value: "unsure",
    },
];

export const BugModal = ({ error, ...rest }: Omit<FeedbackModalProps, "title">) => {
    const [setPriority, setEtop] = useFeedbackStore((state) => [state.setPriority, state.setEtop], shallow);
    return (
        <ModalDialog title="Bug Report" {...rest}>
            <Selector
                title="Importance"
                defaultValue={100}
                list={bugPriorityList}
                onSetValue={(value: number) => setPriority(value)}
            />
            <Selector
                className="mt-8"
                title="Estimated Time of Occurence"
                defaultValue="PT15M"
                list={bugETList}
                onSetValue={(value: string) => setEtop(value)}
            />
            <ProblemInput error={error} />
        </ModalDialog>
    );
};
